import React from "react";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { cn } from "../../lib/utils";
import MarkdownCode from "./MarkdownCode";
import MarkdownBlockquote from "./MarkdownBlockquote";

interface MarkdownStyleProps {
    children: React.ReactNode;
    className?: string;
}

interface MarkdownProps {
    children: string;
    className?: string;
}

export function MarkdownStyle({ children, className }: MarkdownStyleProps) {
    return <div className={cn("prose prose-slate dark:prose-invert prose-headings:font-medium prose-pre:bg-transparent prose-pre:p-0 prose-li:leading-6 prose-img:rounded-lg", className)}>{children}</div>;
}

export default function Markdown({ children, className }: MarkdownProps) {
    return (
        <MarkdownStyle className={className}>
            <ReactMarkdown
                remarkPlugins={[gfm]}
                rehypePlugins={[rehypeRaw]}
                components={{
                    code({ inline, className, children, ...props }) {
                        const match = /language-(\w+)/.exec(className || "");
                        return !inline && match ? (
                            <MarkdownCode {...props} children={String(children).replace(/\n$/, "")} language={match[1]} />
                        ) : (
                            <span className="rounded-lg border border-slate-200 bg-blue-50/50 px-2 py-1 text-sm font-light text-blue-600 shadow-sm dark:border-slate-700 dark:bg-slate-900 dark:text-blue-400">{children}</span>
                        );
                    },
                    blockquote({ children }) {
                        return <MarkdownBlockquote>{children}</MarkdownBlockquote>;
                    }
                }}>
                {children}
            </ReactMarkdown>
        </MarkdownStyle>
    );
}
